<template>
    <div class="form-group form0" :class="{'has-error': validation.hasError('modelo.monto')}">
        <div class="input-group input-group-sm">
            <div ></div>
                <input type="text" v-model.number="modelo.monto" class="form-control" placeholder="Formato numerico">
            </div>
        <div class="error" v-if="validation.hasError('modelo.monto')"> {{validation.firstError('modelo.monto')}} </div>
    </div>
</template>

<script>
import { Validator } from 'simple-vue-validator';
export default {
    props:{ model:Object,valueto:{type:String,required:false,default:null },default:{type:Number,required:false,default:null} },
    data(){
        return{
            datos: [],
            modelo: {
                monto: null,
            }
        }
    },
    watch:{
        'modelo.monto': function(a){
            if(a==null) return;
            if( this.valueto != null ) this.model[this.valueto] = parseInt(a);
            else this.model.monto = parseInt(a); 
        },
        'default': function(){
            // window.console.log( "DEFAULTTTTT ",this.default );
            this.parseDefault();
        },
    },
    validators: {
        'modelo.monto'(value){
            return Validator.value(value).digit().required();
        }
    },
    methods:{
        parseDefault(){
            if( this.default ) {
                var def = parseInt(this.default);
                this.modelo.monto = def;
                // window.console.log( "DEFAULT monto: "+def )
            }
        }
    },
    mounted(){
        this.$validate().then(() => {  });        
        this.parseDefault();
    }
}
</script>